import { render, staticRenderFns } from "./InsolvencyRegistry.vue?vue&type=template&id=1c5f33d5&scoped=true&"
import script from "./InsolvencyRegistry.vue?vue&type=script&lang=js&"
export * from "./InsolvencyRegistry.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyRegistry.vue?vue&type=style&index=0&id=1c5f33d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5f33d5",
  null
  
)

export default component.exports